// Pages
import LandingPage from "./Pages";

function App() {
  return <LandingPage />;
}

export default App;
